import React from "react"
import styles from "./PriceMatchedOverview.module.scss"
import { Col, Row } from "reactstrap"

const PriceMatchedOverview = () => {
  return (
    <section>
      <div className="fw-semibold fs-5 my-3">Price Matched Overview</div>

      <div className="p-1 bg-white">
        <div className="border border-subtle-secondary py-3">
          <Row>
            <Col>
              <div className="text-center fw-medium">
                <span className="me-3">Price Matched Products:</span>
                <span className={styles['text-orange']}>0</span>
              </div>
            </Col>
            <Col>
              <div className="text-center fw-medium">
                <span className="me-3">Orders Increased after price match:</span>
                <span className={styles['text-orange']}>0</span>
              </div>
            </Col>
            <Col>
              <div className="text-center fw-medium">
                <span className="me-3">Sales Increased after price match</span>
                <span className={styles['text-orange']}>0</span>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  )
}

export default PriceMatchedOverview
